// extracted by mini-css-extract-plugin
export default {"FormOfPaymentContainer":"FormOfPayment_FormOfPaymentContainer__iJJ7m","PaymentChoiceButton":"FormOfPayment_PaymentChoiceButton__BW20q"};